export default __webpack_public_path__ + "static/media/bidder_upload_format_upload.68101dbf.csv";